import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { h as handleDismiss } from './p-CY_xCDya.js';
import { d as defineCustomElement$6 } from './p-sF9rvBC9.js';
import { d as defineCustomElement$5 } from './p-BDIehgMZ.js';
import { d as defineCustomElement$4 } from './p-BYQE4OHw.js';
import { d as defineCustomElement$3 } from './p-Trmgzgcp.js';
import { d as defineCustomElement$2 } from './p-KbTC_jnR.js';

const infoboxCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:var(--jw-theme-surface-level1-default-bg-color);border:1px solid var(--jw-theme-surface-border-border-color);border-radius:.375rem;box-sizing:border-box;color:var(--jw-theme-surface-text-default-color);display:flex;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.75rem;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;padding:1rem .75rem}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host ::slotted(p){color:var(--jw-theme-surface-text-default-color)!important;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem}header{align-items:center;display:inline-flex;flex:1;justify-content:space-between}";

const WuiInfobox$1 = /*@__PURE__*/ proxyCustomElement(class WuiInfobox extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.dismiss = createEvent(this, "dismiss", 3);
        //////// DISMISSIBLE START ////////
        this.dismissible = true;
        this.handleDismiss = () => handleDismiss(this);
        //////// DISMISSIBLE END ////////
        /**
         * Tag label
         */
        this.label = 'How to';
    }
    render() {
        return (h(Host, { key: 'f7cdeb4cf5194077db70dcdb34ade8ccf04fc41e' }, (this.label || this.dismissible) && (h("header", { key: '78fb4d7596fa9f0d2df7175a3b3f6d54a118be6e' }, this.label && h("wui-tag", { key: 'f6a0319014913347dfae4f88fa0760f126c26aca', label: this.label, icon: this.icon || 'bulb' }), this.dismissible && h("wui-close-button", { key: '98ba4c05c8de92a08e1fbe9e63b678b6cafbc074', onClick: this.handleDismiss, tooltip: this.tooltip }))), h("slot", { key: 'a09404619a8103a6161584fb706615b61e4a70fc' })));
    }
    get elm() { return this; }
    static get style() { return infoboxCss; }
}, [257, "wui-infobox", {
        "dismissible": [4],
        "label": [1],
        "icon": [1],
        "tooltip": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-infobox", "wui-close-button", "wui-icon", "wui-tag", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-infobox":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiInfobox$1);
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-tag":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiInfobox = WuiInfobox$1;
const defineCustomElement = defineCustomElement$1;

export { WuiInfobox, defineCustomElement };
